import { mountApplications } from '~/wikis/edit';
import { mountMoreActions } from '~/wikis/more_actions';
import { mountWikiSidebar } from '~/wikis/mount_sidebar';

mountWikiSidebar();
mountApplications();
mountMoreActions();
